<template>
    <base-frame
    :isMe="isMe"
    :userType="msgObj.userType"
    :sendType="msgObj.msgStatus"
    @iconClick="iconClick"
    :class="msgObj.relateAnswers && msgObj.relateAnswers.length > 0 ? 'w100' : ''"
    :noBorderBottomRadius="msgObj.relateAnswers && msgObj.relateAnswers.length > 0">
	<div slot="chatmessage" >
		<div 
      :userType="msgObj.userType"
      :sendTime="msgObj.sendTime"
      class="txt"
      :content="msgObj.content"
       v-html="transferWarp(msgObj.content)">
    </div>
		<question-list 
    slot="otherMsg" 
    :tipTxt="msgObj.tipTxt" 
    :questions="msgObj.relateAnswers" 
    :basequestion="msgObj.Basequestion"
    :questiontype="msgObj.Questiontype"
    style="padding: 20px 1px 10px;"
    />
	</div>
      <!-- <question-list slot="otherMsg" :tipTxt="msgObj.tipTxt" :questions="msgObj.relateAnswers" style="padding: 0 10px 10px;"/> -->
    </base-frame>
</template>

<script>
import BaseFrame from './BaseFrame'
import QuestionList from './QuestionList'
import utils from '../../utils/util'

export default {
  name: 'tpl-text',
  components: {
    BaseFrame,
    QuestionList
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  },
  methods: {
    iconClick(type) {
      if (type == 3) {
        Bus.$emit("sendMsg", this.msgObj);
      }
    },
    transferWarp(str, msgid) {
      return utils.transferUrl(utils.transferTxtToEmotion(utils.transferWarp(str)))
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/templates/TplText.vue